import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _keys from "lodash/keys";
import _difference from "lodash/difference";
import * as React from 'react';
// @ts-ignore We have this export in package, but it is not present in typings
import { ThemeContext } from 'react-fela';
import renderComponent from './renderComponent';

// TODO @Bugaa92: deprecated by createComponent.tsx
var UIComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UIComponent, _React$Component);

  _createClass(UIComponent, null, [{
    key: "handledProps",

    /** Array of props to exclude from list of handled ones. */
    get: function get() {
      if (!this._handledPropsCache) {
        this._handledPropsCache = _difference(_keys(this.propTypes), this.unhandledProps).sort();
      }

      return this._handledPropsCache;
    }
  }]);

  function UIComponent(props, context) {
    var _this;

    _classCallCheck(this, UIComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UIComponent).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "childClass", _this.constructor);

    _defineProperty(_assertThisInitialized(_this), "actionHandlers", void 0);

    _defineProperty(_assertThisInitialized(_this), "stardustDebug", null);

    if (process.env.NODE_ENV !== 'production') {
      var child = _this.constructor;
      var childName = child.name;

      if (typeof _this.renderComponent !== 'function') {
        throw new Error("".concat(childName, " extending UIComponent is missing a renderComponent() method."));
      }
    }

    _this.renderComponent = _this.renderComponent.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(UIComponent, [{
    key: "renderComponent",
    value: function renderComponent(config) {
      throw new Error('renderComponent is not implemented.');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return renderComponent({
        className: this.childClass.className,
        displayName: this.childClass.displayName,
        handledProps: this.childClass.handledProps,
        props: this.props,
        state: this.state,
        actionHandlers: this.actionHandlers,
        render: this.renderComponent,
        saveDebug: function saveDebug(updatedDebug) {
          return _this2.stardustDebug = updatedDebug;
        }
      }, this.context);
    }
  }]);

  return UIComponent;
}(React.Component);

_defineProperty(UIComponent, "defaultProps", void 0);

_defineProperty(UIComponent, "displayName", void 0);

_defineProperty(UIComponent, "className", void 0);

_defineProperty(UIComponent, "contextType", ThemeContext);

_defineProperty(UIComponent, "propTypes", void 0);

_defineProperty(UIComponent, "unhandledProps", []);

_defineProperty(UIComponent, "_handledPropsCache", undefined);

export default UIComponent;